import React from 'react';
import PostInvoicePage from './PostInvoicePage';

const PostInvoiceOwnerPage = () => <PostInvoicePage isOwner={true}/>;

export default PostInvoiceOwnerPage;
